import { FileInputButton, triggerToast } from "@qivia/ui";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  selectUploadSupportingDocumentFromBackStatus,
  uploadSupportingDocumentFromBackAsync,
  uploadSupportingDocumentSlice,
} from "../uploadSupportingDocumentSlice";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { AxiosProgressEvent } from "axios";
import "../../../i18n/i18n";

export interface UploadSupportingDocumentButtonProps {
  transactionId: string;
  children?: string | JSX.Element | JSX.Element[];
  setUploadEventInfo: (ape: AxiosProgressEvent) => void;
}

export const UploadSupportingDocumentButton = (
  props: UploadSupportingDocumentButtonProps,
) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const uploadSupportingDocumentFromBackStatus = useAppSelector(
    selectUploadSupportingDocumentFromBackStatus,
  );

  useEffect(() => {
    if (uploadSupportingDocumentFromBackStatus === "success")
      triggerToast(t("supportingDocument.upload.success") || "", "valid");
    if (uploadSupportingDocumentFromBackStatus === "failed") {
      triggerToast(t("supportingDocument.upload.error") || "", "error");
    }
    dispatch(uploadSupportingDocumentSlice.actions.resetUploadStatus());
  }, [uploadSupportingDocumentFromBackStatus, t, dispatch]);

  const readFile = (file: File | null) => {
    if (!file || !props.transactionId) return;

    const regex = /^.+\.(([pP][dD][fF])|([jJ][pP][eE]?[gG])|([pP][nN][gG]))$/;
    const reader = new FileReader();
    reader.onload = () => {
      if (file.name.match(regex)) {
        const content = reader.result;
        if (!content) return;
        void dispatch(
          uploadSupportingDocumentFromBackAsync({
            uuid: props.transactionId,
            fileContent: content,
            onUploadProgress: (p) => props.setUploadEventInfo(p),
            originalFileName: file.name,
          }),
        );
      } else {
        triggerToast(t("supportingDocument.incorrectType") || "", "error");
      }
    };
    reader.readAsArrayBuffer(file);
  };

  return (
    <FileInputButton handleFile={(file) => readFile(file as File)}>
      {props.children}
    </FileInputButton>
  );
};
